<script setup lang="ts">
import { isAndroidApp, isIosApp } from "@/Utils/Ionic";

export interface TcAppProps {
  fullscreen?: boolean;
}

const props = defineProps<TcAppProps>();
</script>

<template>
  <div
    id="container"
    class="app"
    :class="{
      'app--fullscreen': props.fullscreen,
      'ios_grid_app-top': isIosApp(),
      'android_grid_app-top': isAndroidApp(),
    }"
  >
    <slot />
  </div>
</template>

<style scoped lang="scss">
.app {
  flex: 1 1 auto;
  backface-visibility: hidden;
  display: flex;
  flex-direction: column;
  max-width: 100%;
  height: 100%;
  position: relative;

  a {
    cursor: pointer;
  }

  @media (max-width: $breakpoint-m) {
    height: calc(100% - $size-navigation-height-mobile);
    max-height: calc(100% - $size-navigation-height-mobile);
  }

  &--fullscreen {
    height: 100% !important;
  }
}

// Firefox overrides
@-moz-document url-prefix() {
  @media print {
    .app {
      display: block;
    }
  }
}
</style>

<style lang="scss">
.ionic_app {
  &--ios {
    .app {
      @media (max-width: $breakpoint-m) {
        height: calc(100% - ($size-navigation-height-mobile + env(safe-area-inset-bottom)));
        max-height: calc(100% - ($size-navigation-height-mobile + env(safe-area-inset-bottom)));
      }

      &--fullscreen {
        height: calc(100% - env(safe-area-inset-bottom)) !important;
        max-height: calc(100% - env(safe-area-inset-bottom)) !important;
      }
    }
  }

  &--android {
    .app {
      @media (max-width: $breakpoint-m) {
        height: calc(100% - ($size-navigation-height-mobile));
        max-height: calc(100% - ($size-navigation-height-mobile));
      }

      &--fullscreen {
        height: 100% !important;
        max-height: 100% !important;
      }
    }
  }
}
</style>
